var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-card-footer",
    { attrs: { id: "footer", "footer-bg-variant": "light" } },
    [
      _vm._t("footer-update"),
      _vm._v(" "),
      _c(
        "b-row",
        { attrs: { "align-h": "between", "align-v": "center" } },
        [
          _c(
            "b-col",
            { staticClass: "mr-auto", attrs: { cols: "auto" } },
            [
              _vm._t("footer-list", function() {
                return [
                  _vm._v("\n        Записей: "),
                  _c("b", [_vm._v(_vm._s(_vm.totalRows))])
                ]
              })
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { cols: "auto" } },
            [
              _c(
                "b-form",
                { attrs: { inline: "" } },
                [
                  _vm._t("footer-buttons", function() {
                    return [
                      _c("b-pagination-nav", {
                        staticClass: "mr-2",
                        attrs: {
                          pills: "",
                          "link-gen": _vm.linkGen,
                          "number-of-pages": _vm.numberOfPages,
                          "per-page": _vm.perPage
                        },
                        on: { "page-click": _vm.onPagination }
                      }),
                      _vm._v(" "),
                      _c("b-form-select", {
                        staticClass: "mr-2",
                        attrs: {
                          size: "sm",
                          value: _vm.perPage,
                          options: _vm.pageOptions
                        },
                        on: { change: _vm.onPerPageChange }
                      })
                    ]
                  })
                ],
                2
              )
            ],
            1
          )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-00d6124a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-00d6124a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/utilites/commonUi/PaginationFooter.vue
// module id = null
// module chunks = 